/* Compra rápida del restyling (snippets/wim-quick-buy): talla sin elegir al abrir, guía de tallas dentro del modal,
   cambio de color cargando la compra rápida del producto hermano, aviso de reposición en tallas agotadas, favorito de
   Wishlist Hero y cierre deslizando hacia abajo en mobile. */
(function () {
  if (window.__wimQuickBuyBound) return;
  window.__wimQuickBuyBound = true;

  var PENDING = "data-wim-size-pending";

  function qbmOf(element) {
    return element && element.closest ? element.closest("[data-wim-qbm]") : null;
  }

  function ctaText(qbm) {
    return qbm.querySelector("[data-wim-qbm-cta-text]");
  }

  /* Al abrir no se marca ninguna talla: el botón dice «Añadir a la cesta» y pide la talla antes de añadir */
  function setPending(qbm) {
    var cta = qbm.querySelector("[data-wim-qbm-cta]");
    var text = ctaText(qbm);
    if (!qbm.querySelector(".wim-size__n") || !cta || cta.disabled || !text) return;
    qbm.setAttribute(PENDING, "");
    text.setAttribute("data-wim-label", text.textContent);
    text.textContent = qbm.getAttribute("data-wim-add-label");
  }

  function clearPending(qbm) {
    var text = ctaText(qbm);
    var error = qbm.querySelector("[data-wim-size-error]");
    qbm.removeAttribute(PENDING);
    if (error) error.textContent = "";
    if (text && text.hasAttribute("data-wim-label")) {
      text.textContent = text.getAttribute("data-wim-label");
      text.removeAttribute("data-wim-label");
    }
  }

  /* Wishlist Hero solo activa los botones que hay al cargar la página: los de la compra rápida (que se pinta después y
     se vuelve a pintar al cambiar de talla o color) se le pasan con su evento */
  function initWishlist(root) {
    root.querySelectorAll(".wim-qbm__fav .wishlist-hero-custom-button:not([data-wim-wlh])").forEach(function (button) {
      button.setAttribute("data-wim-wlh", "");
      document.dispatchEvent(new CustomEvent("wishlist-hero-add-to-custom-element", { detail: button }));
    });
  }

  function watchWishlist(modal) {
    if (modal.__wimWlhObserver) return;
    modal.__wimWlhObserver = new MutationObserver(function () { initWishlist(modal); });
    modal.__wimWlhObserver.observe(modal, { childList: true, subtree: true });
  }

  function prepare(modal) {
    initWishlist(modal);
    watchWishlist(modal);
    var qbm = modal.querySelector("[data-wim-qbm]");
    if (!qbm) return;
    var name = qbm.querySelector(".wim-qbm__name");
    if (name && name.id) modal.setAttribute("aria-labelledby", name.id);
    setPending(qbm);
  }

  /* dialog:before-show no burbujea: se escucha en captura */
  document.addEventListener("dialog:before-show", function (event) {
    if (event.target.matches && event.target.matches("quick-buy-modal")) prepare(event.target);
  }, true);

  document.addEventListener("click", function (event) {
    var swatch = event.target.closest(".wim-qbm .block-swatch");
    if (!swatch) return;
    var qbm = qbmOf(swatch);
    if (qbm && qbm.hasAttribute(PENDING)) clearPending(qbm);
  });

  document.addEventListener("submit", function (event) {
    if (event.target.closest && event.target.closest("[data-wim-qbm-notify]")) return;
    var qbm = qbmOf(event.target);
    if (!qbm || !qbm.hasAttribute(PENDING)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var guide = qbm.querySelector("[data-wim-qbm-guide]");
    if (guide && !guide.hidden) toggleGuide(qbm, false);
    var error = qbm.querySelector("[data-wim-size-error]");
    if (error) error.textContent = error.getAttribute("data-text");
    var sizes = qbm.querySelector(".variant-picker__option-values:has(.wim-size__n)");
    if (!sizes) return;
    sizes.classList.remove("is-shake");
    void sizes.offsetWidth;
    sizes.classList.add("is-shake");
    var first = sizes.querySelector("input:not(:disabled)");
    if (first) first.focus({ preventScroll: true });
  }, true);

  /* Con la guía abierta y sin talla elegida, el botón dice «Elegir talla» y vuelve a las tallas */
  function setGuideCta(qbm, open) {
    var text = ctaText(qbm);
    if (!text || !qbm.hasAttribute(PENDING)) return;
    text.textContent = open ? qbm.getAttribute("data-wim-guide-label") : qbm.getAttribute("data-wim-add-label");
  }

  /* Guía de tallas: cambia la vista del modal y marca la talla elegida */
  function toggleGuide(qbm, open) {
    var main = qbm.querySelector("[data-wim-qbm-main]");
    var guide = qbm.querySelector("[data-wim-qbm-guide]");
    var opener = qbm.querySelector("[data-wim-qbm-guide-open]");
    if (!main || !guide) return;

    if (open) {
      var size = qbm.hasAttribute(PENDING) ? "" : (qbm.querySelector(".wim-size-legend__n") || { textContent: "" }).textContent.trim();
      guide.querySelectorAll("[data-wim-gsz]").forEach(function (row) {
        row.classList.toggle("is-on", row.getAttribute("data-wim-gsz") === size);
      });
    }

    main.hidden = open;
    guide.hidden = !open;
    setGuideCta(qbm, open);
    if (opener) opener.setAttribute("aria-expanded", open ? "true" : "false");
    var target = open ? guide.querySelector("[data-wim-qbm-guide-close]") : opener;
    if (target) target.focus();
  }

  document.addEventListener("click", function (event) {
    var open = event.target.closest("[data-wim-qbm-guide-open]");
    var close = event.target.closest("[data-wim-qbm-guide-close]");
    var qbm = qbmOf(open || close);
    if (!qbm) return;
    event.preventDefault();
    toggleGuide(qbm, !!open);
  });

  /* Colores: carga la compra rápida del producto hermano en el mismo modal */
  async function loadSibling(button) {
    var modal = button.closest("quick-buy-modal");
    var handle = button.getAttribute("data-wim-qbm-handle");
    if (!modal || !handle || button.getAttribute("aria-busy") === "true") return;
    button.setAttribute("aria-busy", "true");

    try {
      var response = await fetch(window.Shopify.routes.root + "products/" + handle);
      var doc = new DOMParser().parseFromString(await response.text(), "text/html");
      var template = doc.getElementById("quick-buy-content");
      if (!template) throw new Error("quick-buy-content");
      var content = template.content;
      content.querySelectorAll("noscript").forEach(function (item) { item.remove(); });
      modal.setAttribute("handle", handle);
      modal.replaceChildren(document.importNode(content, true));
      prepare(modal);
      var checked = modal.querySelector(".wim-qbm__colors [aria-checked='true']");
      if (checked) checked.focus();
    } catch (error) {
      window.location.href = window.Shopify.routes.root + "products/" + handle;
    }
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(".wim-qbm__colors [data-wim-qbm-handle]");
    if (button) loadSibling(button);
  });

  /* Colores como grupo de radio: flechas para moverse entre ellos */
  document.addEventListener("keydown", function (event) {
    var current = event.target.closest(".wim-qbm__colors [role='radio']");
    if (!current || ["ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp"].indexOf(event.key) === -1) return;
    var items = Array.from(current.parentElement.querySelectorAll("[role='radio']"));
    var step = event.key === "ArrowRight" || event.key === "ArrowDown" ? 1 : -1;
    var next = items[(items.indexOf(current) + step + items.length) % items.length];
    event.preventDefault();
    items.forEach(function (item) { item.tabIndex = item === next ? 0 : -1; });
    next.focus();
  });

  /* Aviso de reposición (talla agotada): da de alta el correo en Klaviyo y vuelve a «Añadir a la cesta» sin talla elegida */
  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  document.addEventListener("submit", async function (event) {
    var form = event.target.closest && event.target.closest("[data-wim-qbm-notify]");
    if (!form) return;
    event.preventDefault();

    var qbm = qbmOf(form);
    var input = form.querySelector("input[type='email']");
    var error = form.querySelector("[data-wim-qbm-notify-error]");
    var button = form.querySelector("button[type='submit']");
    var email = input.value.trim();

    if (!EMAIL.test(email)) {
      error.textContent = form.getAttribute("data-error");
      input.setAttribute("aria-invalid", "true");
      input.focus();
      return;
    }

    input.removeAttribute("aria-invalid");
    error.textContent = "";
    button.setAttribute("aria-busy", "true");

    try {
      await window.wimNotify(form, email, form.getAttribute("data-variant-id"));
    } catch (failure) {
      button.removeAttribute("aria-busy");
      error.textContent = form.getAttribute("data-fail");
      return;
    }

    var ok = qbm && qbm.querySelector("[data-wim-qbm-ok]");
    if (ok) {
      ok.textContent = form.getAttribute("data-ok").replace("[email]", email);
      ok.hidden = false;
    }

    var productForm = qbm && qbm.querySelector("product-form");
    var cta = qbm && qbm.querySelector("[data-wim-qbm-cta]");
    var text = qbm && ctaText(qbm);
    form.hidden = true;
    if (productForm) productForm.hidden = false;
    if (cta) cta.disabled = false;
    if (text) text.textContent = qbm.getAttribute("data-wim-add-label");
    if (qbm) qbm.setAttribute(PENDING, "");
  });

  /* Al pulsar la talla agotada, el foco pasa al campo de correo cuando aparece */
  document.addEventListener("change", function (event) {
    if (!event.target.closest || !event.target.closest(".wim-qbm .variant-picker__option-values")) return;
    var label = event.target.nextElementSibling;
    if (!label || !label.querySelector(".wim-size__note--notify")) return;
    var tries = 0;
    var timer = setInterval(function () {
      var input = document.querySelector(".wim-qbm [data-wim-qbm-notify] input[type='email']");
      if (input || ++tries > 20) {
        clearInterval(timer);
        if (input) input.focus({ preventScroll: true });
      }
    }, 100);
  });

  /* Mobile: deslizar la cabecera hacia abajo cierra el modal */
  var drag = null;

  document.addEventListener("touchstart", function (event) {
    var handle = event.target.closest(".wim-qbm__top, .wim-qbm__head");
    if (!handle || window.matchMedia("(min-width: 700px)").matches) return;
    var modal = handle.closest("quick-buy-modal");
    var content = modal && modal.getShadowPartByName && modal.getShadowPartByName("content");
    if (!content) return;
    drag = { modal: modal, content: content, y: event.touches[0].clientY, dy: 0 };
  }, { passive: true });

  document.addEventListener("touchmove", function (event) {
    if (!drag) return;
    drag.dy = Math.max(0, event.touches[0].clientY - drag.y);
    drag.content.style.transform = "translateY(" + drag.dy + "px)";
  }, { passive: true });

  document.addEventListener("touchend", function () {
    if (!drag) return;
    var current = drag;
    drag = null;
    current.content.style.transform = "";
    if (current.dy > 90) current.modal.hide();
  });
})();
